import {
  GET_WORD_PAIR_FAILURE,
} from '../constants';

export interface IGetWordPairFailure {
  type: typeof GET_WORD_PAIR_FAILURE;
  message: string;
}

type ActionTypes = IGetWordPairFailure;

const errorMessage = (state: string = '', action: ActionTypes): string => {
  switch (action.type) {
    case GET_WORD_PAIR_FAILURE:
      return action.message;
    default:
      return state;
  }
};

export default errorMessage;
